// SPEC-20 · the blocks of a screen the lib answers by its fields
// (`byFields`, Ciclo · sintomas): a written field on top (Outro's
// « Qual? »), then each choice or scale as a labelled block, « QUANDO »
// and « INTENSIDADE ». Which fields show, which are required and what a
// value may be are the lib's; this file only draws them.

import type { FieldValues, Question } from "poweryourflow-lib";

import { Field } from "../components/Field";
import type { QuestionText } from "../i18n/pt-PT";
import type { AnswerValue } from "../schema/types";
import { AnswerInput } from "./AnswerInput";

/** The kinds a field of such a screen can be; a test holds every item list to it. */
export const SCREEN_FIELD_KINDS: readonly Question["kind"][] = ["text", "multi", "scale"];

export function ScreenFields({
  fields,
  text,
  values,
  onChange,
}: {
  fields: readonly Question[];
  text: (fieldId: string) => QuestionText | undefined;
  values: FieldValues;
  onChange: (fieldId: string, value: AnswerValue) => void;
}) {
  return (
    <div className="flex flex-col gap-6">
      {fields.map((field) => {
        const said = text(field.id);
        if (!said) return null;
        const value = values[field.id];
        if (field.kind === "text") {
          return (
            <Field
              key={field.id}
              label={said.title}
              error={null}
              {...(field.maxLength !== undefined && { maxLength: field.maxLength })}
              value={typeof value === "string" ? value : ""}
              onChange={(event) => onChange(field.id, event.target.value)}
            />
          );
        }
        return (
          <section key={field.id} aria-label={said.title} className="flex flex-col gap-1">
            <h2 className="text-label font-semibold tracking-[var(--ls-label)] text-muted uppercase">{said.title}</h2>
            {/* The intensity of a symptom is Orange, the design system's colour for pain (SPEC-20). */}
            <AnswerInput question={field} text={said} value={value} onChange={(next) => onChange(field.id, next)} accent="orange" />
          </section>
        );
      })}
    </div>
  );
}
